var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.85 54.443H27.044c-.378 0-.742.143-1.02.399l-10.228 9.477V22.963a3.917 3.917 0 0 1 3.912-3.912h42.441a3.916 3.916 0 0 1 3.911 3.912v16.036a1.5 1.5 0 0 0 3 0V22.963a6.92 6.92 0 0 0-6.911-6.912H19.708a6.92 6.92 0 0 0-6.912 6.912v44.791a1.5 1.5 0 0 0 2.52 1.101l12.315-11.411h10.218a1.5 1.5 0 1 0 0-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.769 44.784H50.912a5.441 5.441 0 0 0-5.435 5.435v20.045a5.441 5.441 0 0 0 5.435 5.435h24.953l8.842 7.871a1.497 1.497 0 0 0 1.611.248c.539-.241.886-.777.886-1.368V50.219a5.441 5.441 0 0 0-5.435-5.435Zm2.435 34.321-6.771-6.027a1.495 1.495 0 0 0-.997-.38H50.912a2.437 2.437 0 0 1-2.435-2.435V50.218a2.437 2.437 0 0 1 2.435-2.435h30.857a2.437 2.437 0 0 1 2.435 2.435v28.887ZM28.182 30.078a1.5 1.5 0 1 0 0 3h25.494a1.5 1.5 0 0 0 0-3H28.182Zm14.287 10.526H28.181a1.5 1.5 0 1 0 0 3h14.288a1.5 1.5 0 1 0 0-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.169 54.604H56.511a1.5 1.5 0 0 0 0 3h19.658a1.5 1.5 0 0 0 0-3Zm-11.206 8.204h-8.452a1.5 1.5 0 0 0 0 3h8.452a1.5 1.5 0 0 0 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatConversation);
export default __webpack_public_path__ + "static/media/chat-conversation.41690f68b12e98e977a156066daaed2e.svg";
export { ForwardRef as ReactComponent };